/**
 * Вычисляет расстояние Левенштейна между двумя строками
 * @param {string} firstString
 * @param {string} secondString
 * @param {number|null} maxDiff - Максимальное ожидаемое различие для оптимизации.
 *                                Если указано и разница в длине строк больше maxDiff,
 *                                функция сразу возвращает разницу в длине без полного вычисления.
 *                                Если null, выполняется полное вычисление расстояния Левенштейна.
 * @returns {number} - Расстояние Левенштейна между строками
 */
export default function getCharacterDiffCount(firstString, secondString, maxDiff = null) {
    if (!firstString) return secondString.length;
    if (!secondString) return firstString.length;

    const len1 = firstString.length;
    const len2 = secondString.length;

    // Оптимизация: если указан maxDiff и разница в длине больше maxDiff,
    // сразу возвращаем разницу в длине (расстояние не может быть меньше разницы в длине)
    if (maxDiff !== null && Math.abs(len1 - len2) > maxDiff) {
        return Math.abs(len1 - len2);
    }

    const matrix = [];

    for (let i = 0; i <= len1; i++) {
        matrix[i] = [i];
    }
    for (let j = 0; j <= len2; j++) {
        matrix[0][j] = j;
    }

    for (let i = 1; i <= len1; i++) {
        for (let j = 1; j <= len2; j++) {
            if (firstString[i - 1] === secondString[j - 1]) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j] + 1,
                    matrix[i][j - 1] + 1,
                    matrix[i - 1][j - 1] + 1,
                );
            }
        }
    }

    return matrix[len1][len2];
}
